import React, { useEffect } from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignIn, useAuth } from "./clerkReact";
import { getConfigValue } from "../../config/runtimeConfig";
import { appendRedirectUrl } from "./clerkRedirects";
import { useAuthProvider } from "../Authentication/AuthProviderSwitch";
import { hasClientAccess } from "../Authentication/roleAccess";

const ClerkLoginPage = () => {
  const { isSignedIn } = useAuth();
  const { has, orgRole } = useAuthProvider();
  const location = useLocation();
  const navigate = useNavigate();
  const defaultRedirect = getConfigValue(
    "REACT_APP_CLERK_AFTER_SIGN_IN_URL",
    process.env.REACT_APP_CLERK_AFTER_SIGN_IN_URL,
    "/dashboard"
  );
  const redirectTo = location.state?.from?.pathname || defaultRedirect;
  const signInUrl = getConfigValue(
    "REACT_APP_CLERK_SIGN_IN_URL",
    process.env.REACT_APP_CLERK_SIGN_IN_URL,
    "/login"
  );
  const isHostedSignIn = /^https?:\/\//i.test(signInUrl);
  const signedInRedirect = hasClientAccess({ orgRole, has }) ? "/client/account" : redirectTo;

  useEffect(() => {
    if (!isSignedIn) return;
    navigate(signedInRedirect, { replace: true });
  }, [isSignedIn, navigate, signedInRedirect]);

  useEffect(() => {
    if (!isHostedSignIn) return;
    window.location.assign(appendRedirectUrl(signInUrl, redirectTo));
  }, [isHostedSignIn, signInUrl, redirectTo]);

  if (isHostedSignIn) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="gray.50" direction="column" gap={3}>
        <Spinner />
        <Text color="gray.600">Redirecting to sign in…</Text>
      </Flex>
    );
  }

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <SignIn
        routing="path"
        path="/login"
        signUpUrl="/sign-up"
        forceRedirectUrl={redirectTo}
        fallbackRedirectUrl={redirectTo}
      />
    </Flex>
  );
};

export default ClerkLoginPage;
